<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nzCollapsible
    nzWidth="256px"
    nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
  >
    <div class="sidebar-section">
      <div class="sidebar-logo">
        <img
            style="width: 7rem; height: 3.5rem"
            src="assets/img/logo.png"
            alt="logo"
          />
          <h1 class="">SR RENT A CAR</h1>
      </div>
      <ul
        class="side-menu-list"
        nz-menu
        nzTheme="light"
        nzMode="inline"
        [nzInlineCollapsed]="isCollapsed"
      >
        <li *appHasAnyPrivilege="'USER_VIEW,USER_CREATE,ROLE_VIEW,ROLE_CREATE'" nz-submenu
            nzTitle="User Management"
            nzIcon="user"
            [(nzOpen)]="openMap['user']"
            (nzOpenChange)="openHandler('user')">
          <ul>
            <li *appHasAnyPrivilege="'USER_VIEW'" nz-menu-item (click)="routeLink('users')"
                [nzSelected]="router.isActive('/admin/users', true)"
            >
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Users</a>
            </li>
            <li *appHasAnyPrivilege="'USER_CREATE'" nz-menu-item (click)="routeLink('user-add')"
                [nzSelected]="router.isActive('/admin/users/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add User</a>
            </li>
            <li *appHasAnyPrivilege="'ROLE_VIEW'" nz-menu-item (click)="routeLink('roles')"
                [nzSelected]="router.isActive('/admin/users/roles', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Roles</a>
            </li>
            <li *appHasAnyPrivilege="'ROLE_CREATE'" nz-menu-item (click)="routeLink('role-add')"
                [nzSelected]="router.isActive('/admin/users/roles/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Role</a>
            </li>
          </ul>
        </li>
        <li *appHasAnyPrivilege="'FLEET_VIEW,FLEET_CREATE'" nz-submenu
            nzTitle="Fleet Management"
            nzIcon="car"
            [(nzOpen)]="openMap['fleet']"
            (nzOpenChange)="openHandler('fleet')">
          <ul>
            <li *appHasAnyPrivilege="'FLEET_VIEW'" nz-menu-item (click)="routeLink('fleets')" [nzSelected]="router.isActive('/admin/fleets', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Fleets</a>
            </li>
            <li *appHasAnyPrivilege="'FLEET_CREATE'" nz-menu-item (click)="routeLink('fleet-add')" [nzSelected]="router.isActive('/admin/fleets/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Fleet</a>
            </li>
          </ul>
        </li>
        <li *appHasAnyPrivilege="'DRIVER_VIEW,DRIVER_CREATE'" nz-submenu
            nzTitle="Driver Management"
            nzIcon="user-switch"
            [(nzOpen)]="openMap['driver']"
            (nzOpenChange)="openHandler('driver')">
          <ul>
            <li *appHasAnyPrivilege="'DRIVER_VIEW'" nz-menu-item (click)="routeLink('drivers')" [nzSelected]="router.isActive('/admin/drivers', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Drivers</a>
            </li>
            <li *appHasAnyPrivilege="'DRIVER_CREATE'" nz-menu-item (click)="routeLink('driver-add')" [nzSelected]="router.isActive('/admin/drivers/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Driver</a>
            </li>
          </ul>
        </li>
        <li *appHasAnyPrivilege="'SUPPLIER_VIEW,SUPPLIER_CREATE'" nz-submenu
            nzTitle="Supplier Management"
            nzIcon="delivered-procedure"
            [(nzOpen)]="openMap['supplier']"
            (nzOpenChange)="openHandler('supplier')">
          <ul>
            <li *appHasAnyPrivilege="'SUPPLIER_VIEW'" nz-menu-item (click)="routeLink('suppliers')" [nzSelected]="router.isActive('/admin/suppliers', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Suppliers</a>
            </li>
            <li *appHasAnyPrivilege="'SUPPLIER_CREATE'" nz-menu-item (click)="routeLink('supplier-add')" [nzSelected]="router.isActive('/admin/suppliers/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Supplier</a>
            </li>
          </ul>
        </li>
        <li *appHasAnyPrivilege="'CUSTOMER_VIEW,CUSTOMER_CREATE'" nz-submenu
            nzTitle="Customer Management"
            nzIcon="partition"
            [(nzOpen)]="openMap['customer']"
            (nzOpenChange)="openHandler('customer')">
          <ul>
            <li *appHasAnyPrivilege="'CUSTOMER_VIEW'" nz-menu-item (click)="routeLink('customers')" [nzSelected]="router.isActive('/admin/customers', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Customers</a>
            </li>
            <li *appHasAnyPrivilege="'CUSTOMER_CREATE'" nz-menu-item (click)="routeLink('customer-add')" [nzSelected]="router.isActive('/admin/customers/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Customer</a>
            </li>
          </ul>
        </li>
        <li *appHasAnyPrivilege="'AGENT_VIEW,AGENT_CREATE'" nz-submenu
            nzTitle="Agent Management"
            nzIcon="team"
            [(nzOpen)]="openMap['agent']"
            (nzOpenChange)="openHandler('agent')">
          <ul>
            <li *appHasAnyPrivilege="'AGENT_VIEW'" nz-menu-item (click)="routeLink('agents')" [nzSelected]="router.isActive('/admin/agents', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Agents</a>
            </li>
            <li *appHasAnyPrivilege="'AGENT_CREATE'" nz-menu-item (click)="routeLink('agent-add')" [nzSelected]="router.isActive('/admin/agents/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Agent</a>
            </li>
            <li *appHasAnyPrivilege="'AGENT_BOOKING_VIEW'" nz-menu-item (click)="routeLink('agents-booking')" [nzSelected]="router.isActive('/admin/agents/view-booking', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="unordered-list" nzTheme="outline"></span> View Agent
                Bookings</a>
            </li>
          </ul>
        </li>
        <li
          *appHasAnyPrivilege="'TRANSFER_BOOKING_VIEW,TRANSFER_BOOKING_CREATE,RENT_BOOKING_VIEW,RENT_BOOKING_CREATE,OTHER_BOOKING_VIEW,OTHER_BOOKING_CREATE'"
          nz-submenu
          nzTitle="Tour Management"
          nzIcon="global"
          [(nzOpen)]="openMap['booking']"
          (nzOpenChange)="openHandler('booking')">
          <ul>
            <li *appHasAnyPrivilege="'TRANSFER_BOOKING_VIEW'" nz-menu-item (click)="routeLink('booking-transfer')" [nzSelected]="router.isActive('/admin/booking-transfer', true)">
              <a><i-lucide  nz-icon name="{{'folder-symlink'}}" class="w-[16px] h-[16px] mr-2 mt-2 ml-0.5"></i-lucide>
                View Transfer Bookings</a>
            </li>
            <li *appHasAnyPrivilege="'TRANSFER_BOOKING_CREATE'" nz-menu-item (click)="routeLink('booking-transfer-add')" [nzSelected]="router.isActive('/admin/booking-transfer/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Transfer Booking</a>
            </li>
            <li *appHasAnyPrivilege="'RENT_BOOKING_VIEW'" nz-menu-item (click)="routeLink('booking-rent')" [nzSelected]="router.isActive('/admin/booking-rent', true)">
              <a><i-lucide nz-icon name="{{'folder-input' }}" class="w-[16px] h-[16px] mr-2 mt-2 ml-0.5" ></i-lucide>
                View Rent Bookings</a>
            </li>
            <li *appHasAnyPrivilege="'RENT_BOOKING_CREATE'" nz-menu-item (click)="routeLink('booking-rent-add')" [nzSelected]="router.isActive('/admin/booking-rent/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Rent Booking</a>
            </li>
            <li *appHasAnyPrivilege="'OTHER_BOOKING_VIEW'" nz-menu-item (click)="routeLink('booking-other')" [nzSelected]="router.isActive('/admin/booking-other', true)">
              <a><i-lucide nz-icon name="{{'folder-dot' }}" class="w-[16px] h-[16px] mr-2 mt-2 ml-0.5"  ></i-lucide>
                View Other Bookings</a>
            </li>
            <li *appHasAnyPrivilege="'OTHER_BOOKING_CREATE'" nz-menu-item (click)="routeLink('booking-other-add')" [nzSelected]="router.isActive('/admin/booking-other/add-edit', true)">
              <a> <span class="mr-2 ml-1" nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Other Booking</a>
            </li>
          </ul>
        </li>
        <li nz-menu-item [routerLink]="'system-log'" [nzSelected]="router.isActive('/admin/system-log', true)">
          <span nz-icon nzType="database" nzTheme="outline"></span><span>System Log</span>
          <!--        <a> <span class="mr-2" nz-icon nzType="database" nzTheme="outline"></span> {{isCollapsed ? '' : 'System Log'}}</a>-->
        </li>
      </ul>
    </div>
  </nz-sider>
  <nz-layout>
    <nz-header class="header-section">
      <div class="app-header bg-white flex justify-between items-center">
        <span
          class="header-trigger flex items-center"
          (click)="isCollapsed = !isCollapsed"
        >
          <i-lucide
            class="trigger"
            nz-icon
            nzType="{{
              isCollapsed ? 'menu-unfold' : 'menu-fold'
            }}"
            nzTheme="outline"
          ></i-lucide>
        </span>
        <div class="flex items-center gap-3">
          <div class="flex items-center cont-border gap-2 custom-active_btn">
            <div class="pr-1">
              <div class="dot-circle"></div>
            </div>
            <div class="mr-1 md:mr-3 pr-1">
              <p class="text-xs company-badge-topic">Active Department</p>
              <p
                class="text-xs font-bold company-badge-text">{{ departmentName ? departmentName : "All Departments" }}</p>
            </div>
          </div>

          <div class="bg-slate-100 rounded-lg  py-1 px-2 2xl:mr-8 lg:mr-6 mr-6 hover:cursor-pointer custom-admin_btn "
               nz-button
               nz-dropdown
               [nzDropdownMenu]="menu"
               nzPlacement="bottomCenter">
            <div class="more-btn-view">
              <span nz-icon nzType="more" nzTheme="outline" class=""></span>
            </div>
            <div class="pro-details-view">
              <div class="flex items-center gap-2">
                <div>
                  <img
                    *ngIf="loggedInUserProfilePic"
                    class="w-[2rem] h-[2rem] object-cover rounded-full"
                    src="{{ loggedInUserProfilePic }}"
                    alt=""
                  />
                  <img
                    *ngIf="!loggedInUserProfilePic"
                    class="w-[2rem] h-[2rem] object-cover rounded-full"
                    src="assets/img/static/no-user.jpg"
                    alt=""
                  />
                </div>
                <div>
                  <p class="m-0 font-medium text-sm">{{ loggedInUserName }}</p>
                  <p class="m-0 text-xs">
                    {{ loggedInUser?.role?.name | titlecase }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item nz-popconfirm class="more-btn-view">
              <div class="flex items-center gap-2 bg-slate-100 rounded-lg py-1 px-2 ">
                <div>
                  <img
                    *ngIf="loggedInUserProfilePic.length"
                    class="w-[2rem] h-[2rem] object-cover rounded-full"
                    src="{{ loggedInUserProfilePic }}"
                    alt=""
                  />
                  <img
                    *ngIf="!loggedInUserProfilePic.length"
                    class="w-[2rem] h-[2rem] object-cover rounded-full"
                    src="assets/img/static/no-user.jpg"
                    alt=""
                  />
                </div>
                <div>
                  <p class="m-0 font-medium text-sm">{{ loggedInUserName }}</p>
                  <p class="m-0 text-xs">
                    {{ loggedInUser?.role?.name | titlecase }}
                  </p>
                </div>
              </div>
            </li>
            <li
              nz-menu-item
              nz-popconfirm
              nz-button
              routerLink="users/profile"
            >
              Profile
            </li>
            <li nz-submenu nz-popconfirm nzTitle="Department">
              <ul>
                <li
                  *ngFor="let op of userDepartments"
                  nz-menu-item
                  (click)="filterByDepartment(op)"
                >
                  {{
                    op.company
                      ? op.department.name + " - " + op.company.name
                      : op.department.name
                  }}
                </li>
                <li nz-menu-item (click)="filterByDepartment()">All</li>
              </ul>
            </li>
            <li
              *appHasAnyPrivilege="'CURRENCY_VIEW'"
              nz-menu-item
              nz-popconfirm
              nz-button
              routerLink="currency-config"
            >
              Currency Configuration
            </li>
            <li
              nz-menu-item
              nz-popconfirm
              nz-button
              nzDanger
              (click)="logout()"
            >
              Log Out
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content 2xl:p-8 lg:p-6 p-4">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
